module.exports = __webpack_public_path__ + "img/afternoon.be5030ca.webp";